// extracted by mini-css-extract-plugin
export default {"recos":"Z7-z","productCardOverride":"_7-z","rowHasBadge":"a8-z"};